import { layoutRu } from "@/locale/strings/layoutRu";
import { layoutUk } from "@/locale/strings/layoutUk";
import { layoutKy } from "@/locale/strings/layoutKy";
import { layoutKk } from "@/locale/strings/layoutKk";
import { layoutUz } from "@/locale/strings/layoutUz";
import { formsRu } from "@/locale/strings/formsRu";
import { formsUk } from "@/locale/strings/formsUk";
import { formsKy } from "@/locale/strings/formsKy";
import type { AppLang } from "@/locale/appLang";

export type TranslationDict = Record<string, string>;

export const RU_STRINGS: TranslationDict = {
  ...layoutRu,
  ...formsRu,
};

export const UK_STRINGS: TranslationDict = {
  ...layoutUk,
  ...formsUk,
};

export const KY_STRINGS: TranslationDict = {
  ...layoutKy,
  ...formsKy,
};

/** Формы заказа — русский (общий деловой язык СНГ); оболочка сайта — казахский/узбекский. */
export const KK_STRINGS: TranslationDict = {
  ...formsRu,
  ...layoutKk,
};

export const UZ_STRINGS: TranslationDict = {
  ...formsRu,
  ...layoutUz,
};

const BY_LANG: Record<AppLang, TranslationDict> = {
  ru: RU_STRINGS,
  uk: UK_STRINGS,
  kk: KK_STRINGS,
  uz: UZ_STRINGS,
  ky: KY_STRINGS,
};

export function pickStrings(lang: AppLang): TranslationDict {
  return BY_LANG[lang] ?? RU_STRINGS;
}
